export const header = {
  headerTitle: 'Application Timeline',
  headerDescription: 'Shows the key steps in the application process.',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
